<template>
    <div class="schoolAppList">
        <div class="top">
            <el-button
                @click="$router.go(-1)"
                type="default"
                size="medium"
            >返回
            </el-button>
            <a
                v-if="!isOnlyDisplay"
                :href="downLoadHref"
                target="_blank"
                download="activityName"
            >
                <el-button
                    type="primary"
                    size="medium"
                >导出
                </el-button>
            </a>
            <el-radio-group
                v-if="!isOnlyDisplay"
                v-model="isOpen"
                size="medium"
                style="margin-left: 10px;"
                @change="querySchoolModuleListFunc"
            >
                <el-radio-button label="1">已安装</el-radio-button>
                <el-radio-button label="0">未安装</el-radio-button>
            </el-radio-group>
            <el-input
                size="medium"
                class="search-input search-input--right"
                placeholder="应用名称"
                v-model="moduleName"
                @keyup.enter.native="querySchoolModuleListFunc"
            >
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    size="medium"
                    @click="querySchoolModuleListFunc"
                ></el-button>
            </el-input>
        </div>
        <template
            v-if="!isOnlyDisplay"
        >
            <div class="filter-container filter-contain--sub">
                <div>
                    应用类型：
                    <el-radio-group
                        v-model="isIntegrate"
                        size="medium"
                        style="margin-left: 10px;"
                        @change="querySchoolModuleListFunc"
                    >
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button label="1">系统应用</el-radio-button>
                        <el-radio-button label="2">集成应用</el-radio-button>
                    </el-radio-group>
                </div>
                <div>
                    适用类型：
                    <el-radio-group
                        v-model="moduleType"
                        size="medium"
                        style="margin-left: 10px;"
                        @change="querySchoolModuleListFunc"
                    >
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            :label="moduleTypeItem.code"
                            v-for="moduleTypeItem in moduleTypeList"
                        >{{moduleTypeItem.value}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </template>

        <div
            class="app_list_box"
            :style="`height: ${isOnlyDisplay ? (windowHeight - 180) : (windowHeight - 280)}px;`"
        >
            <div
                class="app_list"
                v-if="dataList && dataList.length"
            >
                <div class="app_line_box">
                    <div class="app_box">
                        <div
                            :class="['app_item', isOnlyDisplay ? 'app_item--display' : '']"
                            :key="appIndex"
                            v-for="(appItem, appIndex) in dataList"
                        >
                            <i class="fa fa-edit" v-if="isOpen == 1 && !isOnlyDisplay" @click="editHandler(appItem)"></i>
                            <img
                                class="app_logo_img"
                                :src="appItem.moduleLogo || appItem.logoUrl"
                            >
                            <div class="app_title_wrap">
                                <h2>{{appItem.moduleOtherName || appItem.name}}</h2>
                                <div class="app_prop">{{appItem.profile}}</div>
                                <div class="operation_wrap" v-if="!isOnlyDisplay">
                                  <span
                                      @click="jumpToPage('schoolAppInteDetail', {id: appItem.id, schoolId, isOpen: appItem.isOpen,})"
                                      v-if="appItem.isIntegrate == 2"
                                  >模块介绍</span>
                                    <span
                                        @click="downloadManualFunc(appItem.id)"
                                        v-if="isOpen == 1"
                                    >下载</span>
                                    <span
                                        @click="uninstallFunc(appItem.id)"
                                        v-if="isOpen == 1"
                                    >删除</span>
                                    <span
                                        @click="installFunc(appItem.id)"
                                        v-if="isOpen == 0"
                                    >安装</span>
                                    <span
                                        @click="messageSetting(appItem)"
                                        v-if="appItem.isOpen == 1"
                                    >消息推送</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="no_stu_msg"
                v-else
            >
                <img
                    src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
                    alt=""
                >
                <div>暂无套件</div>
            </div>

            <el-dialog
                title="应用名称设置"
                :visible.sync="isShowEditDialog"
                :close-on-press-escape='false'
                width="600px"
                :lock-scroll="false"
                :close-on-click-modal='false'
                :modal-append-to-body='false'
            >
                <div>
                    <el-form
                        ref="editForm"
                        :model="formData"
                        :rules="formRules"
                        label-width="120px"
                    >
                        <el-form-item
                            label="应用名称"
                            prop="moduleOtherName"
                        >
                            <el-input
                                v-model.trim="formData.moduleOtherName"
                                placeholder="请输入名称"
                                style="width: 400px;"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button
                        size="medium"
                        @click="isShowEditDialog = false"
                    >取 消
                    </el-button>
                    <el-button
                        size="medium"
                        type="primary"
                        @click="editConfirmHandler"
                    >确定
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog
                title="手册"
                :visible.sync="isShowManualDialog"
                :close-on-press-escape='false'
                width="600px"
                :lock-scroll="false"
                :close-on-click-modal='false'
                :modal-append-to-body='false'
            >
                <div>
                    <el-table
                        :data="manualList"
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="manualName"
                            label="手册名称"
                        >
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    @click="getManual(scope.row.manualUrl)"
                                >下载
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>

            <el-dialog
                title="消息推送设置"
                :visible.sync="isShowMessageSettingDialog"
                :close-on-press-escape='false'
                width="600px"
                :lock-scroll="false"
                :close-on-click-modal='false'
                :modal-append-to-body='false'
            >
                <div>
                    <el-form
                        ref="messageForm"
                        :model="messageData"
                        :rules="messageRule"
                        label-width="120px"
                    >
                        <el-form-item
                            label="推送位置"
                            prop="platformMsg"
                        >
                            <el-radio v-model="messageData.platformMsg" label="1">微校+</el-radio>
                            <el-radio v-model="messageData.platformMsg" label="2">农行</el-radio>
                            <el-radio v-model="messageData.platformMsg" label="12">微校+及农行</el-radio>
                        </el-form-item>
                    </el-form>
                </div>
                <div
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button
                        size="medium"
                        @click="isShowMessageSettingDialog = false"
                    >取 消
                    </el-button>
                    <el-button
                        size="medium"
                        type="primary"
                        @click="messageSettingConfirmHandler"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import windowResize from "@/mixins/windowResize";
    import baseMixin from "@/mixins/baseMixin";

    import {getDicByCode} from "@/utils/utils";

    import {
        querySchoolModuleList,
        updateUninstallModule,
        updateInstallModule,
        queryManualByModuleId,
        updateModuleSchool
    } from "@/api/schoolManage";

    export default {
        name: 'schoolAppList',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                isOnlyDisplay: this.$route.query.isOnlyDisplay == 1,

                isIntegrate: "",
                moduleType: "",
                moduleTypeList: [],
                moduleName: "",
                isOpen: 1,
                allDataList: [],
                dataList: [],
                manualList: [],
                isShowManualDialog: false,

                isShowEditDialog: false,
                formData: {
                    moduleOtherName: ''
                },
                formRules: {
                    moduleOtherName: [{required: true, trigger: 'blur', message: '请填写应用名称'}],
                },
                editModule: null,

                isShowMessageSettingDialog: false,
                messageSettingAppItem: null,
                messageData: {
                    platformMsg: '1',
                },
                messageRule: {
                    platformMsg: [{required: true, trigger: 'blur', message: '请选择推送位置'}],
                },
            };
        },
        mixins: [windowResize, baseMixin],
        created() {
            getDicByCode("moduleType").then((data) => {
                this.moduleTypeList = data;
            });
            this.querySchoolModuleListFunc();
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                (vm.schoolId = vm.$route.query.schoolId), vm.querySchoolModuleListFunc();
            });
        },
        computed: {
            downLoadHref() {
                return (
                    (global.command === "production"
                        ? "https://wyms.weixiaojia.cn/wyms"
                        : "http://wyms.weixiaojia.net/wyms") +
                    "/schoolModule/exportInstalled?&token=" +
                    this.$store.getters.token +
                    "&id=" +
                    this.schoolId
                );
            },
        },
        methods: {
            toAddapp() {
                this.$router.push({path: "appManageAdd"});
            },
            toappInfo(appId) {
                this.$router.push({path: "appManageInfo", query: {appId: appId}});
            },
            messageSetting(appItem) {
                this.isShowMessageSettingDialog = true;
                this.messageSettingAppItem = appItem;
                this.messageData.platformMsg = `${appItem.platformMsg}`;
            },
            messageSettingConfirmHandler() {
                this.$refs.messageForm.validate(isValid => {
                    if (isValid) {
                        updateModuleSchool({
                            moduleId: this.messageSettingAppItem.id,
                            moduleLogo: this.messageSettingAppItem.moduleLogo,
                            moduleOtherName: this.messageSettingAppItem.moduleOtherName,
                            schoolId: this.schoolId,
                            platformMsg: this.messageData.platformMsg
                        })
                            .then(() => {
                                this.$message.success('修改成功');
                                this.isShowMessageSettingDialog = false;
                                this.querySchoolModuleListFunc();
                            });
                    }
                })
            },
            editHandler(item) {
                this.editModule = item;
                this.formData.moduleOtherName = item.moduleOtherName;
                this.isShowEditDialog = true;
            },
            editConfirmHandler() {
                this.$refs.editForm.validate(isValid => {
                    if (isValid) {
                        updateModuleSchool({
                            moduleId: this.editModule.id,
                            moduleLogo: this.editModule.moduleLogo,
                            moduleOtherName: this.formData.moduleOtherName,
                            schoolId: this.schoolId,
                            platformMsg: this.editModule.platformMsg
                        })
                            .then(() => {
                                this.$message.success('修改成功');
                                this.isShowEditDialog = false;
                                this.querySchoolModuleListFunc();
                            });
                    }
                })
            },
            querySchoolModuleListFunc() {
                querySchoolModuleList({
                    isIntegrate: this.isIntegrate,
                    isOpen: this.isOpen,
                    moduleName: this.moduleName,
                    moduleType: this.moduleType,
                    schoolId: this.schoolId,
                }).then((data) => {
                    this.dataList = data;
                });
            },
            installFunc(moduleId) {
                this.$confirm("您确定要安装此应用吗？", "安装", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                }).then(() => {
                    updateInstallModule({
                        moduleId,
                        schoolId: this.schoolId,
                    }).then(() => {
                        this.querySchoolModuleListFunc();
                    });
                });
            },
            uninstallFunc(moduleId) {
                this.$confirm("您确定要卸载此应用吗？", "卸载", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false,
                }).then(() => {
                    updateUninstallModule({
                        moduleId,
                        schoolId: this.schoolId,
                    }).then(() => {
                        this.querySchoolModuleListFunc();
                    });
                });
            },
            downloadManualFunc(moduleId) {
                queryManualByModuleId({
                    moduleId,
                }).then((data) => {
                    this.manualList = data;
                    this.isShowManualDialog = true;
                });
            },
            getManual(manualUrl) {
                window.open(manualUrl, "_blank");
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "./../../../styles/mixin";

    .schoolAppList {
        padding: 12px;

        .filter-contain--sub {
            & > div:last-child {
                margin-top: 10px;
            }
        }

        .top {
            border-bottom: 1px solid #e7eaec;
            padding-bottom: 10px;
        }

        .body {
            overflow: auto;
        }

        .el-dialog__body {
            padding: 10px 20px;
        }

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .app_list_box {
            @include scrollBar;

            .app_list {
                .app_line_box {
                    overflow: hidden;

                    .app_title {
                        height: 20px;
                        line-height: 20px;
                        margin-top: 15px;
                        margin-left: 15px;
                        padding-left: 8px;
                        border-left: 4px solid #409eff;
                        font-weight: bold;
                    }

                    .app_box {
                        padding-bottom: 20px;
                        overflow: hidden;

                        .app_item.app_item--display {
                            width: 30%;
                            margin: 1%;
                            padding: 20px;
                            height: auto;
                            box-sizing: border-box;

                            .app_logo_img {
                                width: 60px;
                                height: 60px;
                                margin: 0 10px 0 0;

                            }
                            .app_title_wrap {
                                width: 50%;
                                height: auto;
                                h2 {
                                    margin: 0;
                                }
                            }
                            .app_prop {
                                margin: 6px 0 0;
                            }
                        }
                        .app_item {
                            @include clearfix;
                            position: relative;
                            height: 150px;
                            margin-top: 20px;
                            margin-left: 20px;
                            padding: 10px;
                            box-sizing: border-box;
                            float: left;
                            overflow: hidden;
                            border-radius: 5px;
                            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
                            transition: all 0.2s linear;

                            .fa-edit {
                                position: absolute;
                                top: 27px;
                                right: 27px;
                                color: #409eff;
                                cursor: pointer;
                            }

                            &:hover {
                                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                                transform: translate3d(0, -2px, 0);
                            }

                            .app_logo_img {
                                float: left;
                                width: 90px;
                                height: 90px;
                                margin: 20px 15px 20px 5px;
                                border-radius: 4px;
                            }

                            .app_title_wrap {
                                float: left;
                                /*width: 165px;*/
                                width: 253px;
                                height: 125px;

                                h2 {
                                    font-size: 16px;
                                    font-weight: bold;
                                    width: 100%;
                                    max-height: 42px;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                    overflow: hidden;
                                }

                                .app_prop {
                                    color: #909399;
                                    display: inline-block;
                                    line-height: 20px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    -webkit-line-clamp: 2;
                                    height: 38px;
                                    font-size: 14px;
                                    width: 240px;
                                    white-space: normal;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    word-break: break-all;
                                }

                                .operation_wrap {
                                    font-size: 16px;
                                    margin-top: 8px;

                                    span {
                                        margin-right: 5px;
                                        color: #409eff;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .no_stu_msg {
                text-align: center;
                font-size: 15px;
                color: #999;
                overflow: hidden;

                img {
                    display: block;
                    margin: 30px auto 0;
                }

                div {
                    height: 20px;
                    line-height: 20px;
                    margin-top: -40px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolAppManage/schoolAppList.vue